import React from 'react';
import AmfootballComp from './Amfootball.component';

class Amfootball extends React.Component {
    componentDidMount() {
        AmfootballComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Amfootball;